import { Component, DestroyRef, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { Store } from '@ngrx/store';

import {
  BreadcrumbItem,
  ContentTitleImagePipe,
  HasTitleImagePipe,
  CurrentNewsDetailsBaseComponent,
  INewsState,
} from '@resident-nx/shared';
import { filter } from 'rxjs';
import { ROUTE } from '../../../models';
import { DateTransformPipe } from '../../../pipes/date.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { AsyncPipe } from '@angular/common';
import { LoaderWebComponent, ImageWebComponent } from '@resident-nx/web/ui';
import { BreadcrumbsWebComponent } from '../../atoms/breadcrumbs/breadcrumbs.component';
import { CardWebComponent, Elevation } from '@resident-nx/web/ui';
import { ImmomioButtonComponent } from '@immomio/ui/button';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ImageBorderRadiusEnum } from '@resident-nx/web/util';

@Component({
  standalone: true,
  selector: 'rs-web-current-news-details',
  templateUrl: './news-details.component.html',
  styleUrls: ['./news-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    BreadcrumbsWebComponent,
    ImageWebComponent,
    ImmomioButtonComponent,
    LoaderWebComponent,
    AsyncPipe,
    TranslateModule,
    DateTransformPipe,
    CardWebComponent,
    ContentTitleImagePipe,
    HasTitleImagePipe,
  ],
})
export class CurrentNewsDetailsWebComponent
  extends CurrentNewsDetailsBaseComponent
  implements OnInit
{
  #destroyRef = inject(DestroyRef);
  public breadcrumbs: BreadcrumbItem[] = [
    {
      label: 'main_navigation_news_l',
      url: ROUTE.NEWS,
    },
    {
      label: 'news.current_news_l',
      url: `${ROUTE.NEWS}/${ROUTE.CURRENT_NEWS}`,
    },
  ];

  constructor(
    store: Store<INewsState>,
    private route: ActivatedRoute,
    private router: Router
  ) {
    super(store);
  }

  public ngOnInit(): void {
    this.news$
      .pipe(
        filter(n => n !== null),
        takeUntilDestroyed(this.#destroyRef)
      )
      .subscribe(news => {
        this.breadcrumbs.push({ label: news.title });
      });
  }

  public onNavigateBack() {
    this.router.navigate([ROUTE.NEWS, ROUTE.CURRENT_NEWS]);
  }

  public onNavigate(url: string) {
    this.router.navigate([url]);
  }

  protected readonly Elevation = Elevation;
  protected readonly ImageBorderRadiusEnum = ImageBorderRadiusEnum;
}
